import { render, staticRenderFns } from "./pointtitle.vue?vue&type=template&id=5adb097f&scoped=true&"
import script from "./pointtitle.vue?vue&type=script&lang=js&"
export * from "./pointtitle.vue?vue&type=script&lang=js&"
import style0 from "./pointtitle.vue?vue&type=style&index=0&id=5adb097f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adb097f",
  null
  
)

export default component.exports